export default {"src":"/_next/static/media/picto-women.a690bdbb.svg","height":27,"width":20,"blurWidth":0,"blurHeight":0};